import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-neutral-800 last:border-0" data-id="element-1">
      <button className="w-full py-4 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-2">
        <span className={`text-lg font-medium transition-colors duration-300 ${isOpen ? 'text-gold-500' : 'text-neutral-300 group-hover:text-gold-400'}`} data-id="element-3">
          {title}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gold-500" data-id="element-4" /> : <ChevronDown className="w-5 h-5 text-neutral-500 group-hover:text-gold-400" data-id="element-5" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-6">
        <div className="text-neutral-400 font-light leading-relaxed" data-id="element-7">
          {children}
        </div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
  allowMultiple?: boolean;
}
export function Accordion({
  items,
  allowMultiple = false
}: AccordionProps) {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const toggleItem = (index: number) => {
    if (allowMultiple) {
      setOpenIndexes(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
    } else {
      setOpenIndexes(prev => prev.includes(index) ? [] : [index]);
    }
  };
  return <div className="w-full max-w-2xl mx-auto" data-id="element-8">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndexes.includes(index)} onClick={() => toggleItem(index)} data-id="element-9">
          {item.content}
        </AccordionItem>)}
    </div>;
}